<template>
  <app-base-main
      :hasMagin="false"
      :no-padding="true"
      parentTable
      :table-border-top="true"
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          advancedFiltering
          :screenOptons="screenOptons"
          @determine="filterQuery"
          @clear="filterQuery"
          :isBr="false"
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <gj-select
            v-model="filter.status"
            :options="AdCampaignEnum.SD.statusOption"
            placeholder="状态"
        ></gj-select>
        <gj-select
            v-model="filter.type"
            :options="AdCampaignEnum.SD.targetingTypeOption"
            placeholder="类型"
        ></gj-select>
        <gj-select
            v-if="false"
            v-model="filter.strategy"
            :options="AdCampaignEnum.SD.bidStrategyOption"
            placeholder="竞价策略"
        ></gj-select>
        <gj-select
            v-if="false"
            v-model="filter.servingStatus"
            :options="AdCampaignEnum.SD.outOfBudgetOption"
            placeholder="超出预算"
        ></gj-select>
        <gj-lazy-input
            v-model="filter.keyword"
            placeholder="广告活动名称"
            width="120px"
        ></gj-lazy-input>
        <gj-date-picker
            v-model="filter.date"
            type="daterange"
            :clearable="false"
            tooltip="数据时间"
            :max-day-length="180"
        ></gj-date-picker>
        <template v-if="!$permission('adsSdCampaigns:addOrUpdate')" #right>
          <gj-tool-group
              :helpName="helpName"
              log @viewLog="viewLog"
              help
              setting :table-name="tableName" :table-columns="columns"
              :download="$permission('adsSdCampaigns:export')" download-url="/ads/adsSdCampaigns/export" :download-params="globalParams"
          ></gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template v-if="$permission('adsSdCampaigns:addOrUpdate')" #operate-group>
      <gj-button
          type="primary"
          @click="add"
      >新增广告活动</gj-button>
      <gj-button
          :disabled="!selectedAllIsNot('state', AdCampaignEnum.SD.status.ARCHIVE)"
          @click="adjustBudget">
        调整预算
      </gj-button>
      <gj-button
          :disabled="!selectedAllIsNot('state', AdCampaignEnum.SD.status.ARCHIVE)"
          @click="updateEndDate"
      >修改结束日期</gj-button>
      <gj-button
          :disabled="!selectedAllIs('state', AdCampaignEnum.SD.status.PAUSE)"
          @click="enable(selectedRows)">
        启用
      </gj-button>
      <gj-button
          :disabled="!selectedAllIs('state', AdCampaignEnum.SD.status.ENABLE)"
          @click="pause(selectedRows)">
        暂停
      </gj-button>
      <gj-button
          v-if="$permission('adsSdCampaigns:delete')"
          :disabled="!selectedAllIn('state', [AdCampaignEnum.SD.status.ENABLE, AdCampaignEnum.SD.status.PAUSE])"
          @click="archive">
        归档
      </gj-button>
    </template>
    <template v-if="$permission('adsSdCampaigns:addOrUpdate')" #tool-group>
      <gj-tool-group
          log @viewLog="viewLog"
          help
          setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
          :download="$permission('adsSdCampaigns:export')" download-url="/ads/adsSdCampaigns/export" :download-params="globalParams"
          :helpName="helpName"
      ></gj-tool-group>
    </template>
    <template #table>
<!--      :default-sort = "{prop: 'impressions', order: 'descending'}"-->
      <gj-table
          ref="gjTable"
          adaptParent
          :name="tableName"
          :selection="$permission('adsSdCampaigns:addOrUpdate')"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          sortable="custom"
          :pagination="pagination"
          show-summary
          :selectable="notEqSelectable('state', AdCampaignEnum.SD.status.ARCHIVE)"
          :default-sort="defaultSort"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:status="{ row }">
          <template v-if="$permission('adsSdCampaigns:addOrUpdate')">
            <gj-tag
                v-if="row.state === AdCampaignEnum.SD.status.ARCHIVE"
                color="#AFBACB">已归档</gj-tag>
            <gj-switch
                v-else
                size="small"
                :value="row.state === AdCampaignEnum.SD.status.ENABLE"
                @input="switchStatus($event, row)"
            ></gj-switch>
          </template>
          <template v-else>
            {{row.state | optionText(AdCampaignEnum.SD.statusOption) | defaultShow}}
          </template>
        </template>
        <template v-slot:campaignName="{ row }">
          <template v-if="row.state === AdCampaignEnum.SD.status.ARCHIVE || !$permission('adsSdCampaigns:addOrUpdate')">
            <gj-tooltip
                :text-line="2"
                :content="row.campaignName">
              {{row.campaignName | defaultShow}}
            </gj-tooltip>
          </template>
          <div v-else style="display: flex; align-items: center;">
            <gj-edit-input
                :value="row.campaignName"
                :item="row"
                table-cell-edit
                :validator="campaignNameValidator"
                :on-confirm="updateCampaignName"
                :pop-title="'广告活动名称'">
              <app-sd-ad-route-link
                  :ad-campaign-manager="{marketId, campaign: row, date: filter.date}">
                <gj-tooltip
                    :text-line="2"
                    :content="row.campaignName">
                  {{row.campaignName | defaultShow}}
                </gj-tooltip>
              </app-sd-ad-route-link>
            </gj-edit-input>
            <div class="gj-cell-display-switch">
              <app-ad-route-link :market-id="row.marketId" :type="AdTypeEnum.SD" :campaign="row">
                <gj-tooltip content="新标签页打开" >
                  <gj-icon iconfont="iconxinkaiyeqiandakai" style="font-size: 13px; color: #666; padding: 0 3px;" ></gj-icon>
                </gj-tooltip>
              </app-ad-route-link>
            </div>
          </div>
        </template>
        <template v-slot:op="{row}">
          <gj-button
              type="text"
              @click="viewLog(row)">
            操作日志
          </gj-button>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {LOG_OP_TYPE} from "../../../common/options";
  import {adFields} from "../../../common/fields";
  import {
    adDefaultSortMixin,
    adAdvancedFilteringMixin,
    currencySymbolMixin, initDateMixin,
    inMarketMixin,
    inPortfolioMixin,
    tableNameMixin
  } from "../../../common/mixin";
  import {queryMixin, selectionMixin} from "../../../../../../minxins";
  import {AdCampaignEnum} from "modules/ad/common/enum";
  import AppAdjustBudgetModal from "../../../common/modal/adjust/adjust-budget-modal";
  import AppUpdateEndDateModal from "../../../common/modal/update-date/update-end-date";
  import AppArchiveWarningModal from "../../../common/modal/update-status/archive-warning-modal";
  import AppAddSdAdCampaign from "../../common/modal/add/campaign/add-ad-campaign";
  import AppAdLogModal from "../../../common/modal/log/ad-log-modal";
  import {defaultVal, isMeaningful, isMeaningless} from "../../../../../../utils/common";
  import AppSdAdRouteLink from "../../common/components/ad-route-link";
  import {subDays} from 'date-fns';
  import {convertToDate} from "../../../../../../utils/date.util";
  import {adStore} from "../../../common/store";
  import {getSdAdCampaignPage, updateSdAdCampaign} from "../../../../../../api/ad";
  import { AdTypeEnum } from "modules/ad/common/enum";
  import AppAdRouteLink from "modules/ad/common/components/app-ad-route-link.vue";

  export default {
    name: "app-sd-ad-campaign",
    components: {AppSdAdRouteLink, AppAdRouteLink},
    mixins: [tableNameMixin, inMarketMixin,
      inPortfolioMixin, selectionMixin,
      queryMixin, currencySymbolMixin,
      adDefaultSortMixin, initDateMixin,
      adAdvancedFilteringMixin
    ],
    created() {
      this.columns = [
        adFields.status,
        adFields.campaignName,
        {...adFields.servingStatus, options: AdCampaignEnum.SD.servingStatusOption},
        {...adFields.campaignTargetType, field: 'option:tactic', options: AdCampaignEnum.SD.targetingTypeOption},
        // {...adFields.bidStrategy, options: AdCampaignEnum.SD.bidStrategyOption},
        // adFields.portfolioName,
        adFields.startDate,
        adFields.endDate,
        {...adFields.dailyBudget, field: 'budget'},
        adFields.impressions,
        adFields.clicks,
        adFields.ctr,
        adFields.cost,
        adFields.cpc,
        adFields.orders,
        adFields.cvr,
        adFields.cpa,
        adFields.sales,
        // adFields.orderProductSales,
        adFields.acos,
        // adFields.acoas,
        adFields.roas,
        // adFields.creationDate,
        adFields.op,
      ];
    },
    data() {
      return {
        AdTypeEnum,
        helpName:'sdadmanager',
        tableData: [],
        columns: [],
        AdCampaignEnum: AdCampaignEnum,
        // filter
        filter: {
          timeStamp: null,
          status: AdCampaignEnum.SD.status.ENABLE_PAUSE,
          type: null,
          strategy: null,
          servingStatus: null,
          keyword: null,
          extendSearch: null,
          date: [subDays(new Date(), 6), new Date()],
        },
        // 手动指定需要获取请求的参数的缓存key, 为了解决刷新情况下拿不到嵌套路由正确的key问题，值为当前组件name
        filterStoragekey: 'app-sd-ad-campaign',
        notStorage: true
      }
    },
    watch:{
      $route:{
        handler(){
          if(this.$route.query.timeStamp!=this.filter.timeStamp){
            this.$gjQueryInit()
            this.$gjNoticeQuery()
          }
        },
        immediate: true,
      }
    },
    methods: {
      marketChange(marketId) {
        if (isMeaningful(marketId)) {
          this.$gjNoticeQuery();
        }
      },
      $gjQueryInitParams() {
        return {
          filter: {
            timeStamp: this.$route.query.timeStamp,
            status: AdCampaignEnum.SD.status.ENABLE_PAUSE,
            type: null,
            servingStatus: null,
            keyword: this.$route.query.keyword||null,
            strategy: null,
            extendSearch: null,
            date: this.initDate || [subDays(new Date(), 6), new Date()]
          },
        };
      },
      $gjQuery() {
        if (isMeaningless(this.marketId)) {
          return;
        }
        // 构造查询参数
        const params = {
          model: {
            marketId: this.marketId,
            portfolioId: this.portfolioId,
            campaignName: this.filter.keyword,
            extendSearch: this.filter.extendSearch,
            state: defaultVal(this.filter.status, null),
            tactic: defaultVal(this.filter.type, null),
            bidStrategy: this.filter.strategy,
            startDate: convertToDate(this.filter.date[0]),
            endDate: convertToDate(this.filter.date[1]),
          },
          ...this.queryPagination,
          ...this.querySortEx
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getSdAdCampaignPage(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = this.currencySymbolMixin(data.records, adStore.SD.currencySymbol);
              this.pagination = this.getPagination(data);
            }
          })
          .complete(() => {
            this.loading = false;
          })
      },
      add() {
        this.$gjCreate(AppAddSdAdCampaign, {
          props: {
            marketId: this.marketId,
            portfolioId: this.portfolioId
          },
          on: {
            created: () => {
              this.$gjMessage.success('创建成功');
              this.$gjResetPage();
            }
          }
        });
      },
      campaignNameValidator(name) {
        return isMeaningful(name);
      },
      updateCampaignName(name, row, closeEditor, closeLoading) {
        updateSdAdCampaign({
          marketId: this.marketId,
          campaignIds: [row.campaignId],
          campaignName: name,
        })
          .then(() => {
            this.$gjMessage.success('操作成功');
            closeEditor();
            this.$gjResetPage();
          })
          .complete(() => closeLoading());
      },
      adjustBudget() {
        const modal = this.$gjCreate(AppAdjustBudgetModal, {
          props: {
            currencySymbol: adStore.SD.currencySymbol
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateSdAdCampaign({
                marketId: this.marketId,
                campaignIds: this.selectedRows.map(e => e.campaignId),
                adjustmentType: modal.form.budget.key,
                adjustmentValue: modal.form.budget.value,
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy()
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      switchStatus(open, row) {
        if (open) {
          this.enable([row]);
        } else {
          this.pause([row]);
        }
      },
      enable(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "启用确认",
            content: rows.length > 1 ? `已选择 ${rows.length} 个广告活动，确认启用？`: `确认启用广告活动[${rows[0].campaignName}]`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateSdAdCampaign({
                marketId: this.marketId,
                campaignIds: rows.map(e => e.campaignId),
                state: AdCampaignEnum.SD.status.ENABLE
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      pause(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "停用确认",
            content: rows.length > 1 ? `已选择 ${rows.length} 个广告活动，确认停用？`: `确认停用广告活动[${rows[0].campaignName}]`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateSdAdCampaign({
                marketId: this.marketId,
                campaignIds: rows.map(e => e.campaignId),
                state: AdCampaignEnum.SD.status.PAUSE
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      archive() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "归档确认",
            content: `归档后亚马逊会
            <span style="color: red;font-weight: bold;">删除</span>这些活动，
            不能再开启，
            <span style="color: red;font-weight: bold;">此操作不可逆</span>，
            请谨慎操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateSdAdCampaign({
                marketId: this.marketId,
                campaignIds: this.selectedRows.map(e => e.campaignId),
                state: AdCampaignEnum.SD.status.ARCHIVE
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      updateEndDate() {
        const modal = this.$gjCreate(AppUpdateEndDateModal, {
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateSdAdCampaign({
                marketId: this.marketId,
                campaignIds: this.selectedRows.map(e => e.campaignId),
                endDate: convertToDate(modal.form.date),
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => {
                  modal.confirmLoading = false;
                });
            }
          }
        });
      },
      viewLog(row) {
        this.$gjCreate(AppAdLogModal, {
          props: {
            marketId: this.marketId,
            name: isMeaningful(row) ? row.campaignName : '',
            opId: isMeaningful(row) ? row.campaignId : null,
            adType: LOG_OP_TYPE.SD,
            object: LOG_OP_TYPE.SD.CAMPAIGN
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
